import { IntegrationToken, IntegrationType } from "@supernova-studio/model";
import { z } from "zod";

export const DTOWorkspaceIntegrationOauthInput = z.object({
  type: IntegrationType,
});

export type DTOWorkspaceIntegrationOauthInput = z.infer<typeof DTOWorkspaceIntegrationOauthInput>;

export const DTOWorkspaceIntegrationPATInput = z.object({
  type: IntegrationType,
  token: IntegrationToken,
});

export type DTOWorkspaceIntegrationPATInput = z.infer<typeof DTOWorkspaceIntegrationPATInput>;

export const DTOWorkspaceIntegrationGetGitObjectsInput = z.object({
  organization: z.string().optional(), // Azure Organization | Bitbucket Workspace slug | Gitlab Group and Sub-Groups | Github Account (User or Organization)
  project: z.string().optional(), // Only for Bitbucket and Azure
  repository: z.string().optional(), // For all providers. Pay attention for Gitlab, they call repositories "projects".
  branch: z.string().optional(), // For all providers, useful for PR creations.
  user: z.string().optional(), // Only for Gitlab User Repositories
});

export type DTOWorkspaceIntegrationGetGitObjectsInput = z.infer<typeof DTOWorkspaceIntegrationGetGitObjectsInput>;
